export default __webpack_public_path__ + "20bc68681dcec9e6d8269c0e2c9dce15.png";